import {
  FacebookButton,
  FacebookMessengerButton,
  InstagramButton,
  LinkButton,
  WhatsappButton,
} from 'betterplace-react-components'
import { TCampaign } from 'gql'
import React, { useState } from 'react'
import { CopiedFeedback, facebookAppId, Routes, t, utmParams } from 'shared'
import './sharing_grid_styles.sass'

type SharingGridProps = {
  campaign: Pick<TCampaign, 'slug'>
  utmMedium: string
}

export const SharingGrid = ({ campaign, utmMedium }: SharingGridProps) => {
  const [copyMode, setCopyMode] = useState(false)
  const [copyModeInstagram, setCopyModeInstagram] = useState(false)
  const shareUrl = Routes.campaignURL(campaign.slug)
  const shape = 'round'

  return (
    <div className="sharing-grid">
      <CopiedFeedback copyMode={copyMode} copyModeInstagram={copyModeInstagram} />

      <div className="labeled-share-button">
        <FacebookButton
          boxShadow
          shape={shape}
          shareUrl={shareUrl}
          teaser={t('share.facebook_body')}
          utmParams={utmParams('user_share', utmMedium, 'facebook')}
          content="Facebook"
        />
        <label>Facebook</label>
      </div>

      <div className="labeled-share-button">
        <FacebookMessengerButton
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          facebookAppId={facebookAppId()!}
          shape={shape}
          boxShadow
          shareUrl={shareUrl}
          teaser={t('share.facebook_messenger_body')}
          utmParams={utmParams('user_share', utmMedium, 'facebook_messenger')}
        />
        <label>Messenger</label>
      </div>

      <div className="labeled-share-button">
        <WhatsappButton
          shape={shape}
          boxShadow
          shareUrl={shareUrl}
          teaser={t('share.whatsapp_body')}
          utmParams={utmParams('user_share', utmMedium, 'whatsapp')}
        />
        <label>WhatsApp</label>
      </div>

      <div className="labeled-share-button">
        <InstagramButton
          shape={shape}
          boxShadow
          shareUrl={shareUrl}
          color={copyModeInstagram ? '#2C662D' : undefined}
          beforeOnClick={() => {
            setCopyModeInstagram(true)
            setTimeout(() => {
              setCopyModeInstagram(false)
            }, 3500)
          }}
        />
        <label>Instagram</label>
      </div>

      <div className="labeled-share-button">
        <LinkButton
          shape={shape}
          boxShadow
          shareUrl={shareUrl}
          color={copyMode ? '#2C662D' : ''}
          beforeOnClick={() => {
            setCopyMode(true)
            setTimeout(() => {
              setCopyMode(false)
            }, 2000)
          }}
        />
        <label>{t('misc.copy_link')}</label>
      </div>
    </div>
  )
}
